import type {
  AspOriginalData,
} from '@/models/interface/funTv';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class MutipleMediaService extends ApiFactory {
  constructor() {
    super('MultipleMedia');
  }

  /** Landing Page Music&Tube Version 2 */
  getLandingResource(data: {
    page: number;
    size: number;
    sourceType: number[];
    isRandom: boolean;
  }): Promise<ApiDataResponse<{
    list: Array<{
      sourceType: number;
      sourceId: number;
      timestamp: number;
      chineseTitle: string;
      englishTitle: string;
      coverPhoto: string;
      youTubeUrl: string;
      numOfClicks: number;
    }>;
  }>> {
    return super.post('GetListNoAuth', data);
  }
}
